import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { LanguageService } from 'src/app/@shared/services/language/language.service';
import { SpecialMessage } from 'src/app/modules/route-planner/interfaces/route-planning/gtfs/special-messages/special-message.interface';

@Component({
    selector: 'app-special-message-pop-up-preview',
    templateUrl: './special-message-pop-up-preview.component.html',
    styleUrls: ['./special-message-pop-up-preview.component.scss'],
    standalone: false
})
export class SpecialMessagePopUpPreviewComponent implements OnInit {
  @Input() message: SpecialMessage
  @Input() isLast: boolean
  @Output() pickMessage = new EventEmitter<void>();

  iconName: string

  constructor(private readonly languageService: LanguageService){}

  ngOnInit(): void {
    this.initializeMultiLanguageTexts()
  }

  initializeMultiLanguageTexts() {
    this.languageService.selectedLanguage$.subscribe(language => {
      this.iconName = language.direction === "rtl" ? "chevron-left" : "chevron-right"
    })
  }

  onClick() {
    this.pickMessage.emit();
  }

  isShowHeader(): boolean {
    return this.languageService.getSelectedLanguage().language === 'hebrew'
  }
}
